export default __webpack_public_path__ + "static/media/email-communication-verification.0738c759.png";